import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { SharedService } from 'src/app/core/services/shared.service';
import { translations } from 'src/i18n/translations';
import { SortableHeaderStore, SortableHeaderState, SimpleActionCreator } from '../../helpers/types';

@Component({
  selector: 'app-sortable-header',
  templateUrl: './sortable-header.component.html',
  styleUrls: ['./sortable-header.component.scss']
})
export class SortableHeaderComponent implements OnInit {
  @Input() action: SimpleActionCreator<any>;
  @Input() fieldName: string;
  @Input() headerName: string;
  @Input() state: Observable<SortableHeaderState>;

  constructor(private store: Store<SortableHeaderStore>, private sharedService: SharedService) {}

  ngOnInit(): void {
    this.headerName = translations[this.sharedService.language][this.headerName] || this.headerName;
  }

  sortData(headerName: string): void {
    this.state.pipe(take(1)).subscribe((state: SortableHeaderState) => {
      const params = {
        ...state.params,
        order_by: state.params.order_by === headerName ? `-${headerName}` : headerName,
        offset: 0
      };
      this.store.dispatch(this.action(params));
    });
  }
}
